/* eslint-disable no-unused-vars */
// Skal matche UtfallDodeRovdyr.cs i backend
export enum OutcomeDeadCarnivore {
    Killed = 1,
    ShotDamageConfirmed = 2,
    ShotDamageUnknown  = 3
}
